import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, mergeMap, tap, withLatestFrom } from 'rxjs/operators';

import { DIAGNOSTIC_ORDER_ACTIONS } from '@ispm/test/constants/diagnostic-order.constants';
import { FetchTablelistConfigurationTemplateAction } from './tablelist.actions';
import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import { TABLELIST_ACTIONS } from '../interfaces';
import { TablelistService } from '../services/tablelist.service';
import { SessionStorageService } from '@ispm/shared/services/session-storage.service';

@Injectable()
export class TablelistEffects {

  constructor(
    private actions$: Actions,
    private tablelistService: TablelistService
  ) {
  }

  @Effect({ dispatch: false})
  fetchTablelistConfigurationTemplateAction$: Observable<Action> = this.actions$.pipe(
    ofType<FetchTablelistConfigurationTemplateAction>(TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE),
    tap((action: IgenomicsAction) => {
      const dynamicSearch = action.payload.value.item.dynamicSearch;
      const resource = action.payload.value.item.resource;
      const associationItems = action.payload.value.item.associationItems;
      const queryType = action.payload.value.item.queryType;
      const simpleSearch = action.payload.value.item.simpleSearch;
      // console.log('------------> effect set worklist')
      sessionStorage.setItem(SessionStorageService.CURRENT_WORKLIST_DYNAMIC_SEARCH,
        JSON.stringify({ dynamicSearch, resource, associationItems, queryType, simpleSearch})
      );
    }),
  );

  @Effect({ dispatch: true})
  loadOrdersForTestAllItems$: Observable<Action> = this.actions$.pipe(
    ofType<IgenomicsAction>(TABLELIST_ACTIONS.LOAD_ORDERS_FOR_TEST_ALL_ITEMS),
    withLatestFrom(() => JSON.parse(sessionStorage.getItem(SessionStorageService.CURRENT_WORKLIST_DYNAMIC_SEARCH))),
    mergeMap((data: any) => {
      sessionStorage.setItem(TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE, JSON.stringify({ completed: false}));
      return this.tablelistService.getOrdersForTestAllItems(data).pipe(
          map(orders => {
            sessionStorage.setItem(TABLELIST_ACTIONS.SET_CONFIG_TEMPLATE, JSON.stringify({ completed: true}));
            return ({ type: DIAGNOSTIC_ORDER_ACTIONS.SET_ORDERS_FOR_TEST_ALL_ITEMS, payload: orders});
          })
        );
    })
  );
}
